import { useEffect } from "react"

import useEmployees from "hooks/useEmployees"
import { useUI } from "providers/UIProvider"

import { IEmployee } from "api/querries/useGetEmployees"

import { Container, Center } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import Icon from "components/UI/atoms/Icon"
import Button from "components/UI/atoms/Button"
import EmployeeForm from "./EmployeeForm"
import { useEmployeesContext } from "providers/EmployeesProvider"


const AddEditEmployeeModal = () => {
  const { modals, toggleModal, T } = useUI()
  const { employeePositions } = useEmployeesContext()

  const employeeData: IEmployee = modals.addEditEmployeeModal.data

  const { form: { values, errors, touched, handleSubmit, handleChange, handleBlur, setValues, resetForm, setFieldTouched, setFieldValue } } = useEmployees(employeeData || null)

  const handleClose = () => {
    toggleModal("addEditEmployeeModal", false)
    resetForm()
  }

  useEffect(() => {
    if (employeeData) {
      setValues({
        fullName: employeeData.fullName as string,
        personalCode: employeeData.personalCode as string,
        phoneNumber: employeeData.phoneNumber as string,
        roleId: employeeData.roleId as string,
        salaryPercent: employeeData.salaryPercent as string
      })
    } else {
      resetForm()
    }
  }, [employeeData])

  const washerEmployee = employeePositions.find((employee: any) => employee.label === "მრეცხავი");
  const isWasherRoleId = values?.roleId === washerEmployee?.value
  useEffect(() => {
    if (!isWasherRoleId) {
      setFieldValue("salaryPercent", undefined)
    }


  }, [isWasherRoleId])


  return (
    <Modal
      isOpen={modals.addEditEmployeeModal.isOpened}
      onClose={handleClose}
      title={T("employees.add_employee")}
      styles={{
        width: "566px",
        headerPadding: "20px 15px",
        bodyPadding: "20px 30px"
      }}
    >
      <Container padding={0}>
        <EmployeeForm
          values={values}
          errors={errors}
          handleChange={handleChange}
          setValues={setValues}
          touched={touched}
          handleBlur={handleBlur}
          setFieldTouched={setFieldTouched}
        />
        <Center mt="45px">
          <Button
            text={employeeData ? T("actions.edit") : T("actions.add")}
            onClick={handleSubmit}
            leftIcon={<Icon name="confirm" iconStyles={{ width: "34px", height: "34px" }} />}
            styles={{ width: "iniial", height: "63px", fontSize: "xl" }}
          />
        </Center>
      </Container>
    </Modal>
  )
}

export default AddEditEmployeeModal